import React from 'react';
import { Helmet } from "react-helmet";
import { PROJECTNAME } from '../constants/custom_config';
import { Link } from 'react-router-dom';
import Select from 'react-dropdown-select';
import CreditCardInput from 'react-credit-card-input';
import moment from 'moment';
import { DatePicker, Space,Calendar,TimePicker } from 'antd';
import $ from 'jquery';

import upload_icon from '../assets/images/checkout/upload-icon.svg';
import upload_icon_active from '../assets/images/checkout/upload-icon-active.svg';
import address_icon from '../assets/images/checkout/address-icon.svg';
import address_icon_active from '../assets/images/checkout/address-icon-active.svg';
import date_icon from '../assets/images/checkout/date-icon.svg';
import date_icon_active from '../assets/images/checkout/date-icon-active.svg';


import payment from '../assets/images/checkout/payment.svg';
import active_payment from '../assets/images/checkout/active_payment.svg';
import captcha from '../assets/images/captcha.jpg';

import order_1 from '../assets/images/order-1.jpg';
import edit_icon from '../assets/images/edit_icon.svg';

import Headercanterlogo from './Headercanterlogo';
import Your_Cart_Box from './Your_Cart_Box';

const selectCity = [
    { label: 'Vadodara', value: 'Vadodara' },
    { label: 'Ahemdabad', value: 'Ahemdabad' },
    { label: 'Gandhinagar', value: 'Gandhinagar' }
]
const options = [
    { label: 'Billing Address', value: 'Billing Address' },
    { label: 'North Goa', value: 'North Goa' },
    { label: 'Palakkad', value: 'Palakkad' },
    { label: 'Dunstan', value: 'Dunstan' },
    { label: 'Euroa', value: 'Euroa' },
    { label: 'Bighorn', value: 'Bighorn' },
    { label: 'Acadia', value: 'Acadia' }
];

class Checkout extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            qty: 0
        };
    }
    componentDidMount() {
        window.scrollTo(0, 0);
    }
    changeQty = (e, action) => {
        let qty = this.state.qty;
        if (action === 'plus') {
            qty = parseInt(qty) + parseInt(1);
        } else {
            if (qty > 0) {
                qty = parseInt(qty) - parseInt(1);
            }
        }
        this.setState({
            qty: qty
        })
    }
    render() {
        function onChange(date, dateString) {
            console.log(date, dateString);
        }
        function disabledDate(current) {
            return current > moment().endOf('day');
        }
        const onInputChange = (time, timeString) => {
        console.log(time, timeString);
        };
        function handleDisable() {
            $(this).removeClass('disabled-tab');
        }
        const onPanelChange = (value, mode) => {
            console.log(value.format('YYYY-MM-DD'), mode);
        };
        return (
            <>
                <Helmet>
                    <title>{PROJECTNAME} - Checkout</title>
                </Helmet>
                <Headercanterlogo />
                <div className="checkout-page section-padding">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-8">
                                <div className="checkout-accordion-area">
                                    <div className="accordion" id="accordionExample" >
                                        <div className="accordion-item">
                                            <div className="accordion-header" id="headingOne">
                                                <button className="accordion-button" type="button" data-bs-toggle="collapse"
                                                    data-bs-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                                    <div className="accordion-icons">
                                                        <img src={upload_icon} alt="Cart Summary"
                                                            className="img-fluid non-active" />
                                                        <img src={upload_icon_active} alt="Cart Summary"
                                                            className="img-fluid active" />
                                                    </div>
                                                    <div className="accordion-detail">
                                                        <h4>Upload Prescription (Rx)</h4>
                                                        {/* <i>2 Items</i> */}
                                                    </div>
                                                </button>
                                            </div>
                                            <div id="collapseOne" className="accordion-collapse collapse show"
                                                aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                                <div className="accordion-body">
                                                    <div className="main-box">
                                                        <div className="upload-prescription-box">
                                                            <h5>Upload Prescription (Rx)</h5>
                                                            <p>Upload only <span>jpg</span>,<span>png or pdf</span> files, Size limit is <span>20MB</span></p>
                                                            <div className="input-field-box common-input-field">
                                                                <input type="file" className="common-input-field input-file" placeholder="Browse file"/>
                                                                <button className="main-btn bg-green">Browse</button>
                                                            </div>
                                                        </div>
                                                        <div className="cart-row">
                                                            <div>
                                                                <Link className="common-btn main-btn continue-btn" title="Continue">Continue</Link>
                                                            </div>
                                                            {/* <div>
                                                                <Link className="common-btn accordion-edit" title="Edit Cart">
                                                                    <span>
                                                                        <img src={edit_icon} alt="edit icon"
                                                                            className="img-fluid non-active" />
                                                                    </span> Edit Cart
                                                                </Link>
                                                            </div> */}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="accordion-item disabled-tab" onClick={handleDisable}>
                                            <div className="accordion-header" id="headingTwo">
                                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                                    data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                                    <div className="accordion-icons">
                                                        <img src={address_icon} alt="Delivery & Billing Address"
                                                            className="img-fluid non-active" />
                                                        <img src={address_icon_active} alt="Delivery & Billing Address" className="img-fluid active" />
                                                    </div>
                                                    <div className="accordion-detail">
                                                        <h4>Booking Date & Time</h4>
                                                        {/* <i>2 8 Chestnut St., Floral Park, NY 11001</i> */}
                                                    </div>
                                                </button>
                                            </div>
                                            <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo"
                                                data-bs-parent="#accordionExample">
                                                <div className="accordion-body">
                                                    <form action="#" className="accordion-from">
                                                        <div className="main-box">
                                                            <div className="booking-area">
                                                                <div className="date-picker-area">
                                                                    <h5>Booking Date</h5>
                                                                    <div className="site-calendar-demo-card">
                                                                        <Calendar className="calendar-input" fullscreen={false} onPanelChange={onPanelChange} />
                                                                    </div>
                                                                </div>

                                                                <div className="time-picker-area">
                                                                    <h5>Booking Time</h5>
                                                                    <TimePicker className="common-input-field time-picker-input ant-input" use12Hours format="h:mm a" placeholder="Choose Time" onChange={onInputChange} />
                                                                </div>
                                                            </div>
                                                            <div className="cart-row">
                                                                <div>
                                                                    <Link className="common-btn main-btn continue-btn" title="Continue">Continue</Link>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </form>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="accordion-item disabled-tab" onClick={handleDisable} >
                                            <div className="accordion-header" id="headingThree">
                                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                                    data-bs-target="#collapseThree" aria-expanded="false"
                                                    aria-controls="collapseThree">
                                                    <div className="accordion-icons">
                                                        <img src={date_icon} alt="Delivery / Packaging Instructions" className="img-fluid non-active" />
                                                        <img src={date_icon_active} alt="Delivery / Packaging Instructions" className="img-fluid active" />
                                                    </div>
                                                    <div className="accordion-detail">
                                                        <h4>Patient & Address</h4>
                                                        {/* <i>Leave at my door if I am not around</i> */}
                                                    </div>
                                                </button>
                                            </div>
                                            <div id="collapseThree" className="accordion-collapse collapse"
                                                aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                                                <div className="accordion-body">
                                                    <div className="main-box">
                                                        <div className="patient-address-box">
                                                            <form className="patient-address-form">
                                                                <div className="select-patent-box">
                                                                    <div className="title-box">
                                                                        <h5>Select Patient</h5>
                                                                        <Link className="add-btn">+ Add Patient</Link>
                                                                    </div>
                                                                    <div className="radio-box-group">
                                                                        <div className="radio-box">
                                                                            <input type="radio" className="radio-custom" name="patient-radio" id="radio-input-1"/>
                                                                            <label className="radio-label radio-custom-label label-large" htmlFor="radio-input-1">Yourself</label>
                                                                            <span className="detail-text">Vikash Gupta, M, 32 yrs</span>
                                                                        </div>
                                                                        <div className="radio-box">
                                                                            <input type="radio" className="radio-custom" name="patient-radio" id="radio-input-2"/>
                                                                            <label className="radio-label radio-custom-label label-large" htmlFor="radio-input-2">Spouse</label>
                                                                            <span className="detail-text">Anjali Gupta, F, 31 yrs</span>
                                                                        </div>
                                                                        <div className="radio-box">
                                                                            <input type="radio" className="radio-custom" name="patient-radio" id="radio-input-3"/>
                                                                            <label className="radio-label radio-custom-label label-large" htmlFor="radio-input-3">Child</label>
                                                                            <span className="detail-text">Saurya Gupta, M, 10 yrs</span>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <div className="select-address-box">
                                                                    <div className="title-box">
                                                                        <h5>Select Address</h5>
                                                                        <Link className="add-btn">+ Add Address</Link>
                                                                    </div>
                                                                    <div className="radio-box-group">
                                                                        <div className="radio-box">
                                                                            <input type="radio" className="radio-custom" name="address-radio" id="radio-input-4"/>
                                                                            <label className="radio-label radio-custom-label" htmlFor="radio-input-4">FF-104, Address line 1 Here, Address line 2 here, Vadodara, Gujarat - 391410 </label>
                                                                            <Link className="edit-btn">Edit</Link>
                                                                        </div>
                                                                        <div className="radio-box">
                                                                            <input type="radio" className="radio-custom" name="address-radio" id="radio-input-5"/>
                                                                            <label className="radio-label radio-custom-label" htmlFor="radio-input-5">FF-102, Address line 1 Here, Address line 2 here, Vadodara, Gujarat - 391410 </label>
                                                                            <Link className="edit-btn">Edit</Link>
                                                                        </div>
                                                                        <div className="radio-box">
                                                                            <input type="radio" className="radio-custom" name="address-radio" id="radio-input-6"/>
                                                                            <label className="radio-label radio-custom-label" htmlFor="radio-input-6">FF-101, Address line 1 Here, Address line 2 here, Vadodara, Gujarat - 391410 </label>
                                                                            <Link className="edit-btn">Edit</Link>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <Link className="main-btn continue-btn common-btn">Continue</Link>
                                                            </form>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* <div className="accordion-item">
                                            <div className="accordion-header" id="headingFive">
                                                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                                    data-bs-target="#collapseFive" aria-expanded="false"
                                                    aria-controls="collapseFive">
                                                    <div className="accordion-icons">
                                                        <img src={call_icon} alt="Mobile Number"
                                                            className="img-fluid non-active" />
                                                        <img src={active_call_icon} alt="Mobile Number"
                                                            className="img-fluid active" />
                                                    </div>
                                                    <div className="accordion-detail">
                                                        <h4>Mobile Number</h4>
                                                    </div>
                                                </button>
                                            </div>
                                            <div id="collapseFive" className="accordion-collapse collapse" aria-labelledby="headingFive"
                                                data-bs-parent="#accordionExample">
                                                <div className="accordion-body">
                                                    <p>We use your number to text or call you about your order.</p>
                                                    <div className="row accordion-from">
                                                        <div className="col-md-6">
                                                            <div className="form-group form-field">
                                                                <input id="text_field1" type="number" name="contact_no" className="form-control"
                                                                    placeholder="Mobile Number" required="required" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <button type="button" className="common-btn dark-pink-bg">Save</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div> */}
                                        <div className="accordion-item disabled-tab">
                                            <div className="accordion-header" id="headingSix">
                                                <button className="accordion-button  collapsed" type="button" data-bs-toggle="collapse"
                                                    data-bs-target="#collapseSix" aria-expanded="false" aria-controls="collapseSix">
                                                    <div className="accordion-icons">
                                                        <img src={payment} alt="Payment"
                                                            className="img-fluid non-active" />
                                                        <img src={active_payment} alt="Payment"
                                                            className="img-fluid active" />
                                                    </div>
                                                    <div className="accordion-detail">
                                                        <h4>Payment</h4>
                                                    </div>
                                                </button>
                                            </div>
                                            <div id="collapseSix" className="accordion-collapse collapse" aria-labelledby="headingSix"
                                                data-bs-parent="#accordionExample">
                                                <div className="accordion-body">
                                                    <div className="row">
                                                        <div className="col-md-9">
                                                            <div className="modal-from">
                                                                <p>Add a credit or debit card</p>
                                                                <div className="card-inputbox">
                                                                    <CreditCardInput
                                                                        onError={({ inputName, err }) => console.log(`credit card input error: ${err}`)}
                                                                        cardCVCInputProps={{
                                                                            onBlur: e => console.log('cvc blur', e),
                                                                            onChange: e => console.log('cvc change', e),
                                                                            onError: err => console.log(`cvc error: ${err}`)
                                                                        }}
                                                                        cardExpiryInputProps={{
                                                                            onBlur: e => console.log('expiry blur', e),
                                                                            onChange: e => console.log('expiry change', e),
                                                                            onError: err => console.log(`expiry error: ${err}`)
                                                                        }}
                                                                        cardNumberInputProps={{
                                                                            onBlur: e => console.log('number blur', e),
                                                                            onChange: e => console.log('number change', e),
                                                                            onError: err => console.log(`number error: ${err}`)
                                                                        }}
                                                                    />
                                                                </div>
                                                                <div className="select-dropdown-box">
                                                                    <Select className="form-control custom-select-dropdown" placeholder="City" options={selectCity} onChange={(value) => console.log(value)} />
                                                                </div>
                                                                <div className="captchabox">
                                                                    <img src={captcha} alt="img" className="img-fluid" />
                                                                </div>
                                                                <div className="card_cancel">
                                                                    <button className="common-btn main-btn continue-btn" type="button">Continue</button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="confirm-payment-method">
                                                        <button className="common-btn main-btn">Confirm Payment Method</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4">
                                <Your_Cart_Box />
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
};

export default Checkout;